<template>
  <div class="clearfix">
    <div v-if="cardType">
      <div class="patientCardNew" v-for="(i,index) in list" :key="index">
        <div class="list" :class="i.selected ? 'active':''">
          <slot name="head"></slot>
          <div class="patient-card">
            <div class="patient-card-top">
              <div class="left" style="padding-right: 50px;" @click="choose(i)">
                <img src="../../images/icon_unselect.png" v-if="!i.selected" alt />
                <img src="../../images/icon_select.png" v-else alt />
              </div>
              <div class="right" v-if="!i.selected">
                <Poptip trigger="click" placement="bottom-end" :transfer="true">
                  <img src="../../images/icon_more.png" alt />
                  <div slot="content" style="cursor:pointer">
                    <!-- <div
                    class="message"
                    @click="message()"
                    style="border-bottom: 1px solid #eee;padding: 5px 0;"
                  >
                    <i class="iconfont icon-xiaoxi1" style="margin:0 10px"></i>发送消息
                    </div>-->
                    <div
                      class="message"
                      @click="follow(i)"
                      style="border-bottom: 1px solid #eee;padding: 5px 0;"
                    >
                      <i class="iconfont icon-suifang" style="margin:0 10px"></i>新增随访
                    </div>
                    <div
                      class="message"
                      @click="transfer('transfer',i)"
                      style="border-bottom: 1px solid #eee;padding: 5px 0;"
                    >
                      <i class="iconfont icon-zhuanyi" style="margin:0 10px"></i>转移标签
                    </div>
                    <div
                      class="message"
                      @click="transfer('remove',i)"
                      style="border-bottom: 1px solid #eee;padding: 5px 0;"
                    >
                      <i class="iconfont icon-yichu" style="margin:0 10px"></i>移出标签
                    </div>
                  </div>
                </Poptip>
              </div>
            </div>
            <div @click="patientDetail(i)" style="margin-top: 5px;">
              <div class="patient-card-left">
                <span class="patient-avatar">
                  <img src="../../images/woman.png" v-if="i.gender === 0" />
                  <img src="../../images/man.png" v-else />
                </span>
                <div class="patient-name">{{i.name}}</div>
                <div class="patient-age">{{i.age || '0' }}岁</div>
              </div>
              <div class="patient-card-right" style="margin-top: 8px;">
                <div class="patient-row">
                  <span class="patient-row-tip">末次筛查时间:</span>
                  <span
                    class="patient-row-value"
                  >{{i.last_filtrate ? i.last_filtrate.create_time.substring(0,10) : '--'}}</span>
                </div>
                <div class="patient-row">
                  <span class="patient-row-tip">末次筛查问卷:</span>
                  <span
                    class="patient-row-value"
                  >{{i.last_filtrate ? i.last_filtrate.bind_name : '--'}}</span>
                </div>

                <div
                  class="patient-row"
                  style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: block;width: 100%;"

                >
                  <span
                    class="patient-row-value-group"
                    v-for="(i,index) in i.invisible_groups"
                    :key="index"
                    :style="{backgroundColor: i.color}"
                  >{{i.name}}</span>
                </div>
              </div>
            </div>
          </div>
          <slot name="foot"></slot>
        </div>
      </div>
    </div>

    <div v-else style="margin-right: 20px;">
      <Table :columns="columns" :data="list">
        <template slot-scope="{row}" slot="selected">
          <div @click="choose(row)">
            <img v-if="!row.selected" style="width:20px" src="../../images/icon_unselect.png" alt />
            <img v-else style="width:20px" src="../../images/icon_select.png" alt />
          </div>
        </template>

        <template slot-scope="{row}" slot="name">
          <template>{{row.name}}</template>
        </template>
        <template slot-scope="{row}" slot="age">
          <template>{{row.age || '0'}}</template>
        </template>
        <template slot-scope="{row}" slot="gender">
          <template>{{row.gender === 0 ? '女' : '男' }}</template>
        </template>
        <template slot-scope="{row}" slot="last_filtrate">{{formatFiltrate(row)}}</template>
        <template slot-scope="{row}" slot="id">{{formatFiltrateName(row)}}</template>
        <template slot-scope="{row}" slot="action">
          <caring-button @click="patientDetail(row)">详情</caring-button>
          <caring-button @click="follow(row)">新增随访</caring-button>
          <caring-button @click="transfer('transfer',row)">转移标签</caring-button>
          <caring-button @click="transfer('remove',row)">移出标签</caring-button>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'patientCardNew',
  props: ['list', 'chooseType', 'cardType'],
  data: function () {
    return {
      columns: [
        {
          title: '选择',
          slot: 'selected',
          align: 'center',
        },
        {
          title: '姓名',
          slot: 'name',
          align: 'center',
        },
        {
          title: '年龄',
          slot: 'age',
          align: 'center',
        },
        {
          title: '性别',
          slot: 'gender',
          align: 'center',
        },
        {
          title: '末次筛查时间',
          slot: 'last_filtrate',
          align: 'center',
          width: 150,
        },
        {
          title: '末次筛查问卷',
          slot: 'id',
          align: 'center',
          width: 150,
        },
        {
          title: '操作',
          slot: 'action',
          width: 400,
          align: 'center',
        },
      ],
    }
  },
  methods: {
    message: function () {},
    follow: function (i) {
      this.$emit('followData', i)
    },
    transfer: function (type, i) {
      this.$emit('tagData', type, i)
    },
    remove: function () {},
    patientDetail: function (i) {
      console.log(i)
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'filterBasic',
        title: i.name + '—筛查信息',
        key: `filterBasic?${i.id}`,
        extra: {
          user: i,
        },
      })
    },

    choose: function (i) {
      let self = this
      if (self.chooseType[0] != 'all') {
        i.selected = !i.selected
        self.list.forEach((v) => {
          if (v.id == i.id) {
            v.selected = i.selected
          }
        })
      }
      self.$emit('childData', self.list)
      console.log(self.list)
      self.$forceUpdate()
    },
    formatFiltrate: function (row) {
      let str = '--'
      if (row.last_filtrate) {
        str = row.last_filtrate.create_time.substring(0, 10) || '--'
      }
      return str
    },
    formatFiltrateName: function (row) {
      let str = '--'
      if (row.last_filtrate) {
        str = row.last_filtrate.bind_name || '--'
      }
      return str
    },
  },
  mounted: function () {},
  watch: {
    list(val) {
      this.list = val
    },
    cardType(val) {
      this.cardType = val
    },
  },
}
</script>

<style lang="less">
@import '../../styles/common.less';
.clearfix {
  margin-right: -16px;
  &::after {
    content: '';
    display: block;
    clear: both;
  }
}
.patientCardNew {
  float: left;
  width: 20%;
  background-color: #fff;
  cursor: pointer;
  will-change: transform;
  transition: all 0.2s ease-in-out;
  position: relative;
  box-sizing: border-box;
  padding: 0 16px 16px 0;
  .list {
    flex: 1;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
    border-color: #eee;
    border: 2px solid transparent;
    padding: 10px;
    box-sizing: border-box;
  }
  .list.active {
    box-shadow: none;
    border: 2px solid #4286f1;
  }

  .patient-card {
    .patient-card-top {
      width: 100%;
      padding-bottom: 5px;
      border-bottom: 1px solid #eee;
      display: flex;
      .left {
        img {
          width: 20px;
        }
      }
      .right {
        flex: 1;
        text-align: right;
        img {
          width: 20px;
        }
      }
    }

    .patient-card-left {
      .patient-avatar {
        display: inline-block;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        overflow: hidden;
        float: left;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .patient-name {
        float: left;
        color: #333;
        font-weight: 800;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        line-height: 30px;
        margin: 0 10px;
      }

      .patient-age {
        float: left;
        font-size: 12px;
        line-height: 12px;
        padding: 3px 5px;
        background-color: #faab69;
        border-radius: 4px;
        color: #fff;
        display: inline-block;
        margin-top: 7px;
        transform: scale(0.95);
      }

      &::after {
        clear: both;
        content: '';
        display: block;
        width: 0;
        height: 0;
        visibility: hidden;
      }
    }

    .patient-card-right {
      // flex: 1;
      // width: 0;

      .patient-row {
        height: 27px;
        line-height: 27px;
        color: @sub-color;
        display: flex;

        .patient-row-tip {
          color: @content-color;
          // text-align: justify;
          // display: inline-block;
          // width: 60px;
          height: 27px;
          margin-right: 10px;
        }

        .patient-row-tip:after {
          content: '';
          display: inline-block;
          width: 100%;
        }

        .patient-row-value {
          flex: 1;
          width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          // color: #aaa;
        }
      }
    }
    .more {
      cursor: pointer;
      // position: absolute;
      // right: 10px;
      // top: 10px;
    }
  }

  .patient-row-value-group {
    font-size: 12px;
    line-height: 12px;
    padding: 3px 5px;
    background-color: #faab69;
    border-radius: 4px;
    color: #fff;
    display: inline-block;
    margin-top: 7px;
    transform: scale(0.95);
  }
}

// .patientCardNew:hover {
//   transform: scale(1.06, 1.06, 1.06);
// }
</style>
